// extracted by css-extract-rspack-plugin
var _1 = "description__t3omW";
var _2 = "error__U7oO7";
var _3 = "error__highlight__nDuTn";
var _4 = "label__w_VG3";
var _5 = "required__I3h4y";
export { _1 as "description", _2 as "error", _3 as "error__highlight", _4 as "label", _5 as "required" }
export default { "description": _1, "error": _2, "error__highlight": _3, "label": _4, "required": _5 }
